import { useState, useEffect } from 'react'
import { Tabs, Tab } from 'react-bootstrap'
import LevelTransition from './LevelTransition'
import IndicatorCarousel from './IndicatorCarousel'
import '../../../styles/vertical-carousel.css'

const IndicatorTabs = ({
  indicators_groups,
  activeTab,
  setActiveTab,
  onIndicatorChange,
  currentCode,
  countryMap,
  compareMode,
  compareCountries,
  compareData,
  nav,
  canDownload = true,
}) => {
  const {
    visibleIndicators,
    levelKey,
    navDirection,
    currentIndex,
    setCarouselIndex,
  } = nav

  useEffect(() => {
    if (indicators_groups?.length && !activeTab) {
      setActiveTab(indicators_groups[0].name)
    }
  }, [indicators_groups])

  useEffect(() => {
    const indicator = visibleIndicators[currentIndex]
    if (indicator) onIndicatorChange(indicator)
  }, [visibleIndicators, currentIndex, onIndicatorChange])

  return (
    <Tabs activeKey={activeTab} onSelect={setActiveTab}>
      {indicators_groups?.map(group => (
        <Tab key={group.name} eventKey={group.name} title={group.name}>
          {activeTab === group.name && (
            <LevelTransition levelKey={levelKey} direction={navDirection}>
              {/* key={levelKey} forces a clean remount on level change —
                  no leftover carousel transition state, so no overlap.
                  Sibling navigation within a level doesn't change levelKey,
                  so the horizontal slide there is untouched. */}
              <IndicatorCarousel
                key={levelKey}
                visibleIndicators={visibleIndicators}
                currentIndex={currentIndex}
                onSelect={setCarouselIndex}
                group={group}
                currentCode={currentCode}
                countryMap={countryMap}
                compareMode={compareMode}
                compareData={compareData}
                compareCountries={compareCountries}
                canDownload={canDownload}
              />
            </LevelTransition>
          )}
        </Tab>
      ))}
    </Tabs>
  )
}

export default IndicatorTabs
